import { jsxs as e, jsx as s } from "react/jsx-runtime";
import { TextLink as d } from "../../TextLink/TextLink.es.js";
import { useMultiStyleConfig as p, chakra as n } from "@chakra-ui/react";
const t = ({
  text: i = "Drag and drop",
  buttonLabel: r = "Upload file"
}) => {
  const { heading: o, or: a } = p("FileUploader");
  return /* @__PURE__ */ e(n.span, { __css: o, children: [
    i,
    r && i && /* @__PURE__ */ s(n.span, { __css: a, children: "or" }),
    r && /* @__PURE__ */ s(d, { isBold: !0, variant: "primary", sx: o, children: r })
  ] });
};
export {
  t as Heading
};
//# sourceMappingURL=Heading.es.js.map
